import { render, staticRenderFns } from "./FormResult.vue?vue&type=template&id=ba8dc6ea&scoped=true"
import script from "./FormResult.vue?vue&type=script&lang=js"
export * from "./FormResult.vue?vue&type=script&lang=js"
import style0 from "./FormResult.vue?vue&type=style&index=0&id=ba8dc6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8dc6ea",
  null
  
)

export default component.exports